query MobileScoreData(
	$days: Int!
	$calculationDateFrom: ConditionDateTime
	$calculationDateTo: ConditionDateTime
	$platformFilter: ConditionString
	$appIdFilter: ConditionString
	$unitIdFilter: ConditionString
) {
	mobileScore: score_mobile_products(
		timeframe_days_eq: { value: [$days] }
		calculation_date_ge: $calculationDateFrom
		calculation_date_le: $calculationDateTo
		platform_eq: $platformFilter
		app_id_eq: $appIdFilter
		unit_id_eq: $unitIdFilter
	) {
		calculation_date
		score
		unique_issues
	}
}
